import { addStyles, DefaultTheme } from '../theme';

export const MDL = {
	container: 'mdl-button mdl-button--icon',
};

export const CSS = {
	container: 'c-Button',
	flip: 'c-Button--flip',
	isSmall: 'c-Button--is-small',
	icon: 'c-Button--icon',
};

const smallSize = DefaultTheme.space(6);
addStyles({
	[CSS.container]: {
		userSelect: 'none',
		color: DefaultTheme.font.color.supporting,

		// Overwrite MDL '!important' so 'a' tag does not default to a text cursor on hover
		['&[disabled]:hover']: {
			cursor: 'default !important',
		},
	},
	[CSS.flip]: {
		transform: 'translate(-12px,-12px) rotate(-90deg) !important',
	},
	[CSS.isSmall]: {
		width: smallSize,
		height: smallSize,
		'min-width': smallSize,
		'min-height': smallSize,
		'font-size': '80%',
	},
	[CSS.icon]: {
		'background-color': 'transparent',
	},
});
